var _path, _circle, _circle2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M34.444 28.0786L45.6073 48H26.8573V43.6666H22.6906V48H6.02393L15.4377 28.4656C15.8124 28.8854 16.2096 29.2846 16.6276 29.6614C19.1185 31.9086 22.1638 33.25 24.7739 33.25C27.3841 33.25 30.4294 31.9086 32.9203 29.6614C33.4655 29.171 33.9747 28.6421 34.444 28.0786ZM22.6906 35.3333V41.5833H26.8573V35.3333H22.6906Z",
    clipRule: "evenodd",
    opacity: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.357,
    cy: 22.833,
    r: 2.083,
    fill: "#fff",
    opacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.19,
    cy: 22.833,
    r: 2.083,
    fill: "#fff",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M26.7156 10.5174C30.1496 11.175 33.0272 13.5062 34.3831 16.7289L49.5479 18.6878L48.9589 20.7289H35.1904V20.75C35.1904 26.5 28.8883 31.1667 24.7737 31.1667C20.6591 31.1667 14.357 26.5 14.357 20.75V20.7289H0.589063L0 18.6878L15.1643 16.7289C16.5204 13.5059 19.3985 11.1747 22.8328 10.5174L22.8466 10.3333H18.5237V8.25L23.1177 6.71875L23.4716 2H26.0758L26.4297 6.71875L31.0237 8.25V10.3333H26.7008L26.7156 10.5174ZM24.7737 20.75L31.0237 18.6667V14.5L24.7737 16.5833L18.5237 14.5V18.6667L24.7737 20.75Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.d49872406933e6ce08865df4a8a0d8a3.svg";
export { ForwardRef as ReactComponent };